module.exports = __webpack_public_path__ + "static/Gilroy-Bold-3ca17cce1c4f3024d70da4447f5b7d50.woff";